
import Vue from 'vue';
import moment from 'moment';
import { ScrollPicker } from 'vue-scroll-picker';
import 'vue-scroll-picker/dist/style.css';

const MIN_IN_AN_HOUR = 60;
const MIN_STEP = 5;

export default Vue.extend({
  components: {
    ScrollPicker,
  },

  data() {
    return {
      hour: '',
      minute: '',
    };
  },

  created() {
    this.setCurrentTime();
  },

  watch: {
    hour: function () {
      this.$emit('input', this.currentTime);
    },

    minute: function () {
      this.$emit('input', this.currentTime);
    },
  },

  computed: {
    currentTime() {
      return `${this.$data.hour}:${this.$data.minute}`;
    },

    hours() {
      return [
        '00',
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12',
        '13',
        '14',
        '15',
        '16',
        '17',
        '18',
        '19',
        '20',
        '21',
        '22',
        '23',
      ];
    },
    minutes() {
      return [...Array(MIN_IN_AN_HOUR / MIN_STEP).keys()].map((v) => String(v * MIN_STEP).padStart(2, '0'));
    },
  },

  methods: {
    setCurrentTime() {
      const [hour, minute] = moment().format('HH:mm:ss.SSS').split(':');
      this.hour = hour;
      this.minute = minute;
    },
  },
});
